import { Signal, TypedSignal } from "@/data/util/Signal";

import { BaseController } from "@/app/controller/BaseController";

export type PreorderTimeControllerShownEventData = {
    isMainNavigation: boolean;
};

export class PreorderTimeController extends BaseController {
    public onContinue?: { () };
    public onShowServices?: { () };

    static onInit = new Signal();
    static onShown = new TypedSignal<PreorderTimeControllerShownEventData | undefined>();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onShowServices = new Signal();

    constructor() {
        super("preorder-time");

        PreorderTimeController.onContinue.add(this.continue, this);
        PreorderTimeController.onShowServices.add(this.showServices, this);

        PreorderTimeController.onInit.dispatch();
    }

    protected onBecomeVisible(options?: PreorderTimeControllerShownEventData) {
        PreorderTimeController.onShown.dispatch(options);
    }

    protected onBecomeInvisible() {
        PreorderTimeController.onHidden.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
